import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a29ccadc51f86a90a77f6489ea4b147d2b from "./generated-381eb46e-ff7f-4e12-bb02-0b856787e8da.json";

import a1c6a1f238397cc88d64d8f38db412e07b from "./generated-f899cf34-216f-470d-a144-897a803659cd.json";

import a0b5ec7aa58cfa1c959634815f2176acbb from "./generated-f0fe472d-35e5-4091-8641-7fd06a783ca0.json";

import a5eb4d54fdb97a30545f0ac6ed1c714e8b from "./generated-0961b44b-6ac1-4bf0-b7f4-020b99ee2ac8.json";

import a92048a83d4bc2d28e61158c28c299926b from "./generated-ea258b6c-ed14-4d28-9c34-48e2b750fb72.json";

import a68038e4af3bcfb8270c2cad0971ccae6b from "./generated-b8810200-3517-4e2f-b93f-e3250f8d9750.json";

import afb3fe5485c2bdd054190858dcf352386b from "./generated-7700aca8-793e-40a9-8ed0-ef3f4331d401.json";

import a54f7e3bef8a11e8cced735422103b7e4b from "./generated-2eae457c-d9bd-4fb0-9926-334bdd2e2a72.json";

import a44456e5575dd68d895a8c6520d897d0bb from "./generated-87e43663-e69a-4d7e-9868-dc7d35dcf6be.json";

import aaeb87b02f1fea148f61663986ebd59c3b from "./generated-de4a73d3-e818-49e0-a65d-e0ee586082ba.json";

import a6e411e1576be63d69059e25208ebf7f2b from "./generated-2bf7e768-8dcd-4eaa-a6fc-7032f0713c7e.json";

import aa3ec1d28cff42714c2a3581e9aa369abb from "./generated-e9330504-3348-427d-810b-6d061d77dea5.json";

import ae48d6ed70fec7b81998f2fbcc89b3ce6b from "./generated-c371c42c-5cb5-4652-98bf-b6327bd1d972.json";

import a47c5773d429a7c6c102c3bb601476d65b from "./generated-263b619a-6b28-4a90-baaf-90ff383d57c5.json";

import a59b30586825005f030b0a3e2427d16f5b from "./generated-54bfbfaa-58ec-4224-b807-4ebd02d79644.json";

import ab7399aa2a289b1f58049236c53c8d492b from "./generated-536ed2d5-0569-47b9-8bf4-0a3458663a77.json";

import a0229e93220c5eaf6ce2859186eff5b36b from "./generated-134d6f81-58da-48b8-b46a-1db8f86ae5ab.json";

import a00deeb93b8e80f788c555127dcd07fabb from "./generated-dc109ae4-6758-49c2-9242-691f8b3b436b.json";

import a25afd60f3349fba5fe458dc5e7489ba4b from "./generated-75415566-c077-41f2-824e-e283b711302c.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a29ccadc51f86a90a77f6489ea4b147d2b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a1c6a1f238397cc88d64d8f38db412e07b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a0b5ec7aa58cfa1c959634815f2176acbb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a5eb4d54fdb97a30545f0ac6ed1c714e8b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a92048a83d4bc2d28e61158c28c299926b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a68038e4af3bcfb8270c2cad0971ccae6b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(afb3fe5485c2bdd054190858dcf352386b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a54f7e3bef8a11e8cced735422103b7e4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a44456e5575dd68d895a8c6520d897d0bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(aaeb87b02f1fea148f61663986ebd59c3b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6e411e1576be63d69059e25208ebf7f2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(aa3ec1d28cff42714c2a3581e9aa369abb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ae48d6ed70fec7b81998f2fbcc89b3ce6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a47c5773d429a7c6c102c3bb601476d65b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a59b30586825005f030b0a3e2427d16f5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ab7399aa2a289b1f58049236c53c8d492b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a0229e93220c5eaf6ce2859186eff5b36b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a00deeb93b8e80f788c555127dcd07fabb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a25afd60f3349fba5fe458dc5e7489ba4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a0229e93220c5eaf6ce2859186eff5b36b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */